import React from 'react'
import Contact from './Contact'

const ContactContainer = () => {
    return <Contact/>
}

export default ContactContainer